import { createContext, type Dispatch, type SetStateAction } from 'react';

export interface LanguageContextType {
    siteLang: 'nb' | 'en';
    setSiteLang: Dispatch<SetStateAction<'nb' | 'en'>>;
}

export const initialLanguageContextValue: LanguageContextType = {
    siteLang: 'nb',
    setSiteLang: () => undefined,
};

export const LanguageContext = createContext<LanguageContextType>(initialLanguageContextValue);
